import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlagComponent } from './flag/flag.component';
import { HeaderFiveComponent } from './header/header-five/header-five.component';
import { HeaderfourComponent } from './header/headerfour/headerfour.component';
import { CalsoftHeaderComponent } from './header/HeaderOne/HeaderOne.component';
import { HeaderThreeComponent } from './header/HeaderThree/HeaderThree.component';
import { HeaderTwoComponent } from './header/HeaderTwo/header-two.component';
import { LanguageComponent } from './language/language.component';
import { LogoComponent } from './logo/logo.component';
import { MenuComponent } from './menu/menu/menu.component';
import { NestedChildComponent } from './menu/menu/nested-child/nested-child.component';
import { SideBarMenuComponent } from './menu/menu/side-bar-menu/side-bar-menu.component';
import { SearchComponent } from './search/search.component';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MobileHeaderComponent } from './header/mobile-header/mobile-header.component';
import { SubscriberComponent } from './subscriber/subscriber.component';
import { MatListModule } from '@angular/material/list';
import { HeaderUserProfileDropdownComponent } from './header/HeaderUserProfileDropdown/HeaderUserProfileDropdown.component';
import { GoogleAnalyticsDirectiveModule } from 'src/app/shared/google-analytics-directive/google-analytics-directive.module';
import { CallComponent } from './header/call/call.component';
import { Menu2Component } from './menu/menu/menu2/menu2.component';
import { HeaderSixComponent } from './header/header-six/header-six.component';
import { HeaderSevenComponent } from './header/header-seven/header-seven.component';
import { HeaderEightComponent } from './header/header-eight/header-eight.component';
import { HeadernineComponent } from './header/headernine/headernine.component';
import { MobileHeaderFixedComponent } from './header/mobile-header-fixed/mobile-header-fixed.component';
import { CartIconComponent } from './header/cart-icon/cart-icon.component';
import { MenuIterationComponent } from './menu/menu/menu-iteration/menu-iteration.component';
import { FooterComponent } from './footer/footer.component';
import { Footer1Component } from './footer1/footer1.component';
import { Footer3Component } from './footer3/footer3.component';
import { Footer2Component } from './footer2/footer2.component';
import { SubscriberButtonComponent } from './subscriber-button/subscriber-button.component';
import { Footer4Component } from './footer4/footer4.component';
import { Header10Component } from './header/header10/header10.component';
import { MobileHeaderFixedWhiteComponent } from './header/mobile-header-fixed-white/mobile-header-fixed-white.component';
import { Header13Component } from './header/header13/header13.component';
import { Header14Component } from './header/header14/header14.component';
import { Header15Component } from './header/header15/header15.component';
import { PincodeComponent } from '../pincode/pincode.component';
import { PincodeModule } from '../pincode/pincode.module';
import { Search2Component } from './search/search2/search2.component';
import { Header11Component } from './header/header11/header11.component';
import { LeftMenuComponent } from './menu/left-menu/left-menu.component';
import { LeftMenuSubComponent } from './menu/left-menu-sub/left-menu-sub.component';
import { Menu3Component } from './menu/menu3/menu3.component';
import { Header12Component } from './header/header12/header12.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { Header16Component } from './header/header16/header16.component';
import { Header18Component } from './header/header18/header18.component';
import { Header17Component } from './header/header17/header17.component';
import { Header19Component } from './header/header19/header19.component';
import { PipesModule } from "../pipes/pipes.module";
import { Header20Component } from './header/header20/header20.component';
import { Header21Component } from './header/header21/header21.component';
import { MenuIteration2Component } from './menu/menu/menu-iteration2/menu-iteration2.component';
import { MobileHeaderNewComponent } from './header/mobile-header-new/mobile-header-new.component';
import { Footer5Component } from './footer5/footer5.component';
import { Header22Component } from './header/header22/header22.component';
import { Header23Component } from './header/header23/header23.component';
import { Header24Component } from './header/header24/header24.component';
import { Header25Component } from './header/header25/header25.component';
import { NewsletterAdsComponent } from './newsletter-ads/newsletter-ads.component';
import { Header26Component } from './header/header26/header26.component';
import { HoveremenuComponent } from './menu/hoveremenu/hoveremenu.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { FooterHeaderComponent } from './footer-header/footer-header.component';
import { Header27Component } from './header/header27/header27.component';
import { Search3Component } from './search/search3/search3.component';
import { Header28Component } from './header/header28/header28.component';
import { Header29Component } from './header/header29/header29.component';
import { Header30Component } from './header/header30/header30.component';
import { Header31Component } from './header/header31/header31.component';
import { Footer6Component } from './footer6/footer6.component';
import { Footer7Component } from './footer7/footer7.component';
import { Header32Component } from './header/header32/header32.component';
import { DynamicFormPopupComponent } from './dynamic-form-popup/dynamic-form-popup.component';
import { DynamicComponentModule } from 'src/app/shared/component/dynamic-component.module';
import { ButtonCategoryComponent } from './menu/button-category/button-category.component';
import { ButtonDialogComponent } from './menu/button-dialog/button-dialog.component';
import { MobileHeader3Component } from './header/mobile-header3/mobile-header3.component';
import { Header33Component } from './header/header33/header33.component';
import { Header34Component } from './header/header34/header34.component';
import { Header35Component } from './header/header35/header35.component';
import { Footer8Component } from './footer8/footer8.component';
import { SubscriberButton2Component } from './subscriber-button2/subscriber-button2.component';
import { SidemenuChildComponent } from './menu/menu/side-bar-menu/sidemenu-child/sidemenu-child.component';
import { MobileHeader4Component } from './header/mobile-header4/mobile-header4.component';
import { SidebarMenuNewComponent } from './menu/menu/side-bar-menu/sidebar-menu-new/sidebar-menu-new.component';
import { MobileHeader5Component } from './header/mobile-header5/mobile-header5.component';
import { BookPopupComponent } from './header/book-popup/book-popup.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Footer9Component } from './footer9/footer9.component';
import { Header36Component } from './header/header36/header36.component';
import { Header37Component } from './header/header37/header37.component';
import { Header38Component } from './header/header38/header38.component';
import { Header39Component } from './header/header39/header39.component';
import { Header40Component } from './header/header40/header40.component';
import { MobileHeader6Component } from './header/mobile-header6/mobile-header6.component';
import { Header41Component } from './header/header41/header41.component';
import { ButtonCategory2Component } from './menu/button-category2/button-category2.component';
import { MobileHeader7Component } from './header/mobile-header7/mobile-header7.component';
import { Header42Component } from './header/header42/header42.component';
import { MobileHeader8Component } from './header/mobile-header8/mobile-header8.component';
import { MenuIteration3Component } from './menu/menu/menu-iteration3/menu-iteration3.component';
import { Footer10Component } from './footer10/footer10.component';
import { Search4Component } from './search/search4/search4.component';
import { SearchWithBgComponent } from './search-with-bg/search-with-bg.component';
import { Header43Component } from './header/header43/header43.component';
import { Header44Component } from './header/header44/header44.component';
import { ScrollingNavigationComponent } from './scrolling-navigation/scrolling-navigation.component';
import { Header45Component } from './header/header45/header45.component';
import { MobileHeader9Component } from './header/mobile-header9/mobile-header9.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideBarMenuPopupComponent } from './menu/menu/side-bar-menu/side-bar-menu-popup/side-bar-menu-popup.component';
import { SideBarChildPopupComponent } from './menu/menu/side-bar-menu/side-bar-menu-popup/side-bar-child-popup/side-bar-child-popup.component';
import { Header46Component } from './header/header46/header46.component';
import { SubscriberButton3Component } from './subscriber-button3/subscriber-button3.component';
import { Header47Component } from './header/header47/header47.component';
import { Header48halameatComponent } from './header/header48halameat/header48halameat.component';
import { Search5Component } from './search/search5/search5.component';
import { MobileHeader10Component } from './header/mobile-header10/mobile-header10.component';
import { Footer11Component } from './footer11/footer11.component';
import { PinCodePopUpComponent } from './header/pin-code-pop-up/pin-code-pop-up.component';
import { Header49Component } from './header/header49/header49.component';
import { MobileHeader11Component } from './header/mobile-header11/mobile-header11.component';
import { Header50Component } from './header/header50/header50.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
@NgModule({
    declarations: [
        CalsoftHeaderComponent,
        HeaderTwoComponent,
        ScrollingNavigationComponent,
        HeaderThreeComponent,
        HeaderfourComponent,
        HeaderFiveComponent,
        MenuComponent,
        NestedChildComponent,
        SideBarMenuComponent,
        SearchComponent,
        LogoComponent,
        LanguageComponent,
        FlagComponent,
        MobileHeaderComponent,
        SubscriberComponent,
        HeaderUserProfileDropdownComponent,
        CallComponent,
        Menu2Component,
        HeaderSixComponent,
        HeaderSevenComponent,
        HeaderEightComponent,
        HeadernineComponent,
        MobileHeaderFixedComponent,
        CartIconComponent,
        MenuIterationComponent,
        FooterComponent,
        Footer1Component,
        Footer3Component,
        Footer2Component,
        SubscriberButtonComponent,
        Footer4Component,
        Header10Component,
        MobileHeaderFixedWhiteComponent,
        Header13Component,
        Header14Component,
        Header15Component,
        Search2Component,
        Header11Component,
        LeftMenuComponent,
        LeftMenuSubComponent,
        Menu3Component,
        Header12Component,
        Header16Component,
        Header18Component,
        Header17Component,
        Header19Component,
        Header20Component,
        Header21Component,
        MenuIteration2Component,
        MobileHeaderNewComponent,
        Footer5Component,
        Header22Component,
        Header23Component,
        Header24Component,
        Header25Component,
        NewsletterAdsComponent,
        Header26Component,
        HoveremenuComponent,
        FooterHeaderComponent,
        Header27Component,
        Search3Component,
        Header28Component,
        Header29Component,
        Header30Component,
        Header31Component,
        Footer6Component,
        Footer7Component,
        Header32Component,
        DynamicFormPopupComponent,
        ButtonCategoryComponent,
        ButtonDialogComponent,
        MobileHeader3Component,
        Header33Component,
        Header34Component,
        Header35Component,
        Footer8Component,
        SubscriberButton2Component,
        SidemenuChildComponent,
        MobileHeader4Component,
        SidebarMenuNewComponent,
        MobileHeader5Component,
        BookPopupComponent,
        Footer9Component,
        Header36Component,
        Header37Component,
        Header38Component,
        Header39Component,
        Header40Component,
        MobileHeader6Component,
        Header41Component,
        ButtonCategory2Component,
        MobileHeader7Component,
        Header42Component,
        MobileHeader8Component,
        MenuIteration3Component,
        Footer10Component,
        Search4Component,
        SearchWithBgComponent,
        Header43Component,
        Header44Component,
        Header45Component,
        SideBarChildPopupComponent,
        SideBarMenuPopupComponent,
        MobileHeader9Component,
        Header46Component,
        SubscriberButton3Component,
        Header47Component,
        Header48halameatComponent,
        Search5Component,
        MobileHeader10Component,
        Footer11Component,
        PinCodePopUpComponent,
        Header49Component,
        MobileHeader11Component,
        Header50Component,

    ],
    exports: [
        RouterModule,
        CalsoftHeaderComponent,
        HeaderTwoComponent,
        HeaderThreeComponent,
        HeaderfourComponent,
        HeaderFiveComponent,
        MenuComponent,
        NestedChildComponent,
        SideBarMenuComponent,
        LogoComponent,
        CustomFlexLayoutModule,
        CallComponent,
        HeaderSixComponent,
        HeaderSevenComponent,
        HeaderEightComponent,
        HeadernineComponent,
        MobileHeaderFixedComponent,
        MenuIterationComponent,
        FooterComponent,
        Footer1Component,
        Footer2Component,
        Footer3Component,
        Footer4Component,
        SubscriberButtonComponent,
        Header10Component,
        MobileHeaderFixedWhiteComponent,
        Header13Component,
        Header14Component,
        Header15Component,
        Header11Component,
        LeftMenuComponent,
        LeftMenuSubComponent,
        Header12Component,
        Header16Component,
        Header18Component,
        Header17Component,
        Header19Component,
        Header20Component,
        Header21Component,
        Header22Component,
        MobileHeaderNewComponent,
        Footer5Component,
        Header23Component,
        Header24Component,
        Header25Component,
        NewsletterAdsComponent,
        Header26Component,
        FooterHeaderComponent,
        Header27Component,
        Search3Component,
        Header28Component,
        Header29Component,
        Header30Component,
        Header31Component,
        Footer6Component,
        Footer7Component,
        Header32Component,
        DynamicFormPopupComponent,
        MobileHeader3Component,
        Header33Component,
        Header34Component,
        ScrollingNavigationComponent,
        Header35Component,
        Footer8Component,
        SubscriberButton2Component,
        MobileHeader4Component,
        MobileHeader5Component,
        Footer9Component,
        Header36Component,
        Header37Component,
        Header38Component,
        Header39Component,
        LeftMenuComponent,
        Header40Component,
        MobileHeader6Component,
        Header41Component,
        MobileHeader7Component,
        Header42Component,
        Footer10Component,
        SearchWithBgComponent,
        Header43Component,
        Header44Component,
        Header45Component,
        Header46Component,
        Header47Component,
        SubscriberButton3Component,
        Header48halameatComponent,
        Footer11Component,
        Header49Component,
        MobileHeader11Component,
        Header50Component,
    ],
    imports: [
        RouterModule,
        CommonModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        CustomFlexLayoutModule,
        MatDividerModule,
        RouterModule,
        MatAutocompleteModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatMenuModule,
        MatListModule,
        GoogleAnalyticsDirectiveModule,
        PincodeModule,
        MatPaginatorModule,
        MatDialogModule,
        MatDividerModule,
        MatIconModule,
        MatAutocompleteModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        FormsModule,
        MatToolbarModule,
        MatTableModule,
        ReactiveFormsModule,
        CustomFlexLayoutModule,
        PipesModule,
        LazyLoadImageModule,
        DynamicComponentModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatSidenavModule,
        GoogleSigninButtonModule
    ]
})
export class ComponentModule { }
